<template>
  <aside class="menu menu--sidebar is-collapsed">
    <ul class="menu-list">
      <li v-if="matched('instance-subscription-purchases')">

        <permissions-control-wrapper
           action="label.purchase_new_subscription"
          :required-general="$PERMISSIONS_GENERAL.BUY_SUBSCRIPTION"
          :permissions="_get(InstanceSubscriptionsList, 'meta.permissions')">
          <router-link
             slot="allowed"
             tag="a" activeClass="is-active"
            :title="$t('label.purchase_new_subscription')"
            :to="{ name: 'instance-subscription-purchase-new' }">
            <nuttrema-iconica-sidebar-link icon="far fa-plus" theme="add-button"></nuttrema-iconica-sidebar-link>
          </router-link>
          <nuttrema-iconica-sidebar-link slot="not-allowed" icon="far fa-plus" theme="add-button" disabled></nuttrema-iconica-sidebar-link>
        </permissions-control-wrapper>

      </li>
    </ul>
  </aside>
</template>

<script>
import { find } from 'lodash';
import NuttremaIconicaSidebarLink from 'components/ui/label/nuttrema-iconica-sidebar-link';
import SidebarIconLevelZero from 'components/ui/menu/level-zero/sidebar-icon-level-zero';

export default {
  name: 'cmpt-menu-collapsed-top-instance',
  components: {
    SidebarIconLevelZero,
    NuttremaIconicaSidebarLink,
  },
  methods: {
    matched(name) {
      return find(this.$route.matched, { name });
    },
  },
  computed: {
    InstanceSubscriptionsList() {
      return this.$store.getters.InstanceSubscriptionsList;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/instance/shared/cmpt-menu-collapsed-top-instance.vue